<template>
  <b-card>
    <div slot="header">
      <div class="row align-items-center">
        <div class="col-8">
          <h3 class="mb-0">{{ $t('college-registration-form.title') }}</h3>
        </div>
      </div>
    </div>

    <!-- 步驟進度條 -->
    <van-steps :active="current_step - 1" active-color="#5e72e4" class="mb-4" v-if="!submitted">
      <van-step>{{ $t('college-registration-form.basic.title') }}</van-step>
      <van-step>{{ $t('college-registration-form.study.title') }}</van-step>
      <van-step>{{ $t('college-registration-form.confirm.title') }}</van-step>
    </van-steps>

    <ValidationObserver ref="observer" v-slot="{ handleSubmit }" v-if="!submitted">
      <form @submit.prevent="handleSubmit(onActualSubmit)">
        <!-- 第一步：基本資料 -->
        <div v-if="current_step === 1">
          <van-divider
            :style="{ color: 'blue', borderColor: 'blue', 'font-size': '1.5em' }"
          >{{ $t('college-registration-form.basic.title') }}</van-divider>
          <div class="pl-lg-4">
            <!--姓名、生日-->
            <div class="row">
              <div class="col-lg-6">
                <ValidationProvider :name="$t('college-registration-form.basic.label.name')" rules="required" v-slot="{ errors, valid }">
                  <b-form-group :label="$t('college-registration-form.basic.label.name')" label-for="input-name" :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
                    <b-form-input id="input-name" autocomplete="name" v-model="form.name" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col-lg-6">
                <ValidationProvider :name="$t('college-registration-form.basic.label.birth-date')" rules="required" v-slot="{ errors, valid }">
                  <b-form-group :label="$t('college-registration-form.basic.label.birth-date')" label-for="input-birth-date" :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
                    <b-form-input id="input-birth-date" type="date" autocomplete="bday" v-model="form.birth_date" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </div>
            </div>

            <!--性別、學歷-->
            <div class="row">
              <div class="col-lg-6">
                <ValidationProvider :name="$t('college-registration-form.basic.label.gender')" rules="required" v-slot="{ errors, valid }">
                  <b-form-group :label="$t('college-registration-form.basic.label.gender')" label-for="input-gender" :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
                    <b-form-select id="input-gender" v-model="form.gender" :state="errors[0] ? false : (valid ? true : null)">
                      <template v-if="constant">
                        <b-form-select-option :value="null" disabled>{{ $t('college-registration-form.basic.gender-selector.hint') }}</b-form-select-option>
                        <b-form-select-option v-for="(value, key) in constant.genders" :key="key" :value="key">
                          {{ $i18n.locale === 'tw' ? value.tw : value.en }}
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col-lg-6">
                <b-form-group :label="$t('college-registration-form.basic.label.education')" label-for="input-education">
                  <b-form-select id="input-education" v-model="form.education">
                    <template v-if="constant">
                      <b-form-select-option :value="null">{{ $t('college-registration-form.basic.education-selector.hint') }}</b-form-select-option>
                      <b-form-select-option v-for="(value, key) in constant.educations" :key="key" :value="key">
                        {{ $i18n.locale === 'tw' ? value.tw : value.en }}
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </div>
            </div>

            <!--電話、手機-->
            <div class="row">
              <div class="col-lg-12">
                <p class="text-muted small mb-2">
                  <i class="fa fa-info-circle mr-1"></i>
                  {{ $t('college-registration-form.basic.instruction-text.phone-required') }}
                </p>
              </div>
              <div class="col-lg-6">
                <ValidationProvider :name="$t('college-registration-form.basic.label.phone')" :rules="{ regex: /^[\d\s\-\+\(\)]+$/, required: !form.mobile_phone }" v-slot="{ errors, valid }">
                  <b-form-group :label="$t('college-registration-form.basic.label.phone')" label-for="input-phone" :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
                    <b-form-input id="input-phone" autocomplete="tel" v-model="form.phone" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col-lg-6">
                <ValidationProvider :name="$t('college-registration-form.basic.label.mobile-phone')" :rules="{ regex: /^[\d\s\-\+\(\)]+$/, required: !form.phone }" v-slot="{ errors, valid }">
                  <b-form-group :label="$t('college-registration-form.basic.label.mobile-phone')" label-for="input-mobile-phone" :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
                    <b-form-input id="input-mobile-phone" autocomplete="tel" v-model="form.mobile_phone" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </div>
            </div>

            <!--email、Line-->
            <div class="row">
              <div class="col-lg-6">
                <b-form-group :label="$t('college-registration-form.basic.label.email')" label-for="input-email">
                  <b-form-input id="input-email" type="email" autocomplete="email" v-model="form.email"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
                <b-form-group :label="$t('college-registration-form.basic.label.line-id')" label-for="input-line-id">
                  <b-form-input id="input-line-id" v-model="form.line_id"></b-form-input>
                </b-form-group>
              </div>
            </div>

            <!--組織、地址-->
            <div class="row">
              <div class="col-lg-12">
                <b-form-group :label="$t('college-registration-form.basic.label.organization')" label-for="input-organization">
                  <b-form-input id="input-organization" autocomplete="organization" v-model="form.organization"></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ValidationProvider :name="$t('college-registration-form.basic.label.address')" rules="required" v-slot="{ errors, valid }">
                  <b-form-group :label="$t('college-registration-form.basic.label.address')" label-for="input-address" :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
                    <b-form-input id="input-address" v-model="form.address" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>

        <!-- 第二步：選擇課程 -->
        <div v-if="current_step === 2">
          <van-divider
            :style="{ color: 'teal', borderColor: 'teal', 'font-size': '1.5em' }"
          >{{ $t('college-registration-form.study.title') }}</van-divider>
          <div class="pl-lg-4">
            <!-- 課程選擇 -->
            <div class="row">
              <div class="col-md-12">
                <ValidationProvider :name="$t('college-registration-form.study.label.primary-department')" rules="required" v-slot="{ errors, valid }">
                  <b-form-group :label="$t('college-registration-form.study.label.primary-department')" label-for="input-primary-dept" :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
                    <b-form-select id="input-primary-dept" v-model="form.primary_department_id" :state="errors[0] ? false : (valid ? true : null)">
                      <b-form-select-option v-for="department in departments" :key="department.id" :value="department.id">
                        {{ department.name }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </ValidationProvider>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ValidationProvider :name="$t('college-registration-form.study.label.other-departments')" v-slot="{ errors, valid }">
                  <b-form-group :label="$t('college-registration-form.study.label.other-departments')" :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
                    <div v-if="is_primary_exclusive" class="text-danger mt-1">
                      {{ $t('college-registration-form.study.notice-message.exclusive-limit', { department: getDepartmentName(form.primary_department_id) }) }}
                    </div>
                    <div v-else>
                      <div v-if="is_limit_reached" class="text-warning mt-1 mb-2">
                        {{ $t('college-registration-form.study.notice-message.limit-reached') }}
                      </div>
                      <b-form-checkbox-group v-model="form.other_department_ids">
                        <b-form-checkbox
                          v-for="department in available_other_departments"
                          :key="department.id"
                          :value="department.id"
                          :disabled="is_limit_reached && !form.other_department_ids.includes(department.id)"
                        >
                          {{ department.name }}
                        </b-form-checkbox>
                      </b-form-checkbox-group>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </div>
            </div>

            <!-- 學佛背景資訊 -->
            <hr class="my-4">
            <div class="row">
              <div class="col-md-12">
                <b-form-group :label="$t('college-registration-form.study.label.buddhist-background')" label-for="input-buddhist-background">
                  <b-form-textarea id="input-buddhist-background" v-model="form.buddhist_background" rows="3"></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group :label="$t('college-registration-form.study.label.studied-sutras')" label-for="input-studied-sutras">
                  <b-form-textarea id="input-studied-sutras" v-model="form.studied_sutras" rows="3"></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group :label="$t('college-registration-form.study.label.favorite-sutras')" label-for="input-favorite-sutras">
                  <b-form-textarea id="input-favorite-sutras" v-model="form.favorite_sutras" rows="3"></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group :label="$t('college-registration-form.study.label.expectations')" label-for="input-expectations">
                  <b-form-textarea id="input-expectations" v-model="form.expectations" rows="3"></b-form-textarea>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <!-- 第三步：確認報名 -->
        <div v-if="current_step === 3">
          <van-divider
            :style="{ color: 'orange', borderColor: 'orange', 'font-size': '1.5em' }"
          >{{ $t('college-registration-form.confirm.title') }}</van-divider>
          <div class="pl-lg-4 pb-4">
            <h5 class="text-primary mb-3"><i class="fa fa-user-circle mr-2"></i>{{ $t('college-registration-form.basic.title') }}</h5>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.name') }}:</b-col>
              <b-col sm="9" class="font-weight-bold">{{ form.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.birth-date') }}:</b-col>
              <b-col sm="9">{{ form.birth_date }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.gender') }}:</b-col>
              <b-col sm="9">{{ constant && constant.genders[form.gender] ? ($i18n.locale === 'tw' ? constant.genders[form.gender].tw : constant.genders[form.gender].en) : form.gender }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.education') }}:</b-col>
              <b-col sm="9">{{ constant && constant.educations[form.education] ? ($i18n.locale === 'tw' ? constant.educations[form.education].tw : constant.educations[form.education].en) : form.education }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.phone') }}:</b-col>
              <b-col sm="9">{{ form.phone }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.mobile-phone') }}:</b-col>
              <b-col sm="9">{{ form.mobile_phone }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.email') }}:</b-col>
              <b-col sm="9">{{ form.email }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.line-id') }}:</b-col>
              <b-col sm="9">{{ form.line_id || '-' }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.organization') }}:</b-col>
              <b-col sm="9">{{ form.organization || '-' }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.basic.label.address') }}:</b-col>
              <b-col sm="9">{{ form.address }}</b-col>
            </b-row>

            <h5 class="text-primary mb-3 mt-4"><i class="fa fa-book mr-2"></i>{{ $t('college-registration-form.study.title') }}</h5>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.study.label.primary-department') }}:</b-col>
              <b-col sm="9" class="font-weight-bold">{{ getDepartmentName(form.primary_department_id) }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.study.label.other-departments') }}:</b-col>
              <b-col sm="9">{{ getSelectedDepartmentsNames() || '-' }}</b-col>
            </b-row>
            <b-row class="mb-2" v-if="form.buddhist_background">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.study.label.buddhist-background') }}:</b-col>
              <b-col sm="9" style="white-space: pre-wrap;">{{ form.buddhist_background }}</b-col>
            </b-row>
            <b-row class="mb-2" v-if="form.studied_sutras">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.study.label.studied-sutras') }}:</b-col>
              <b-col sm="9" style="white-space: pre-wrap;">{{ form.studied_sutras }}</b-col>
            </b-row>
            <b-row class="mb-2" v-if="form.favorite_sutras">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.study.label.favorite-sutras') }}:</b-col>
              <b-col sm="9" style="white-space: pre-wrap;">{{ form.favorite_sutras }}</b-col>
            </b-row>
            <b-row class="mb-2" v-if="form.expectations">
              <b-col sm="3" class="text-muted">{{ $t('college-registration-form.study.label.expectations') }}:</b-col>
              <b-col sm="9" style="white-space: pre-wrap;">{{ form.expectations }}</b-col>
            </b-row>
          </div>
        </div>
        
        <div class="col-12 text-center mt-5">
          <b-button v-show="current_step > 1" type="button" variant="outline-primary" @click="prevStep" class="mr-2" :disabled="loading">{{ $t('college-registration-form.button.prev-step.label') }}</b-button>
          <b-button v-show="current_step < 3" type="button" variant="primary" @click="nextStep">{{ $t('college-registration-form.button.next-step.label') }}</b-button>
          <b-button v-show="current_step === 3" type="submit" variant="success" :disabled="loading">
            <b-spinner v-if="loading" small class="mr-1"></b-spinner>
            {{ $t('college-registration-form.button.submit.label') }}
          </b-button>
        </div>
      </form>
    </ValidationObserver>

    <!-- 報名成功訊息頁面 -->
    <div v-else class="text-center py-5">
      <div class="mb-4">
        <i class="fa fa-check-circle text-success" style="font-size: 5rem;"></i>
      </div>
      <h2 class="text-success mb-3">{{ $t('college-registration-form.success.title') }}</h2>
      <p class="lead px-lg-5">{{ $t('college-registration-form.success.message') }}</p>
      <div class="mt-5">
        <b-button variant="primary" :to="{ name: 'college', params: { id: collegeId } }">{{ $t('academy.title') }}</b-button>
        <b-button variant="danger" :to="{ name: 'index' }">{{ $i18n.locale === 'tw' ? '回首頁' : 'Back to Home' }}</b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
import Vue from 'vue'
import {
  CardPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormSelectPlugin,
  FormTextareaPlugin,
  FormCheckboxPlugin,
  ButtonPlugin,
  LayoutPlugin
} from 'bootstrap-vue'
import { Steps, Step, Divider } from 'vant'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import zh_TW from 'vee-validate/dist/locale/zh_TW.json';
import en from 'vee-validate/dist/locale/en.json';

import ConstantApiService from '@/services/budaedu-api-services/constant-api-service.js'
import CollegeRegistrationApiService from '@/services/budaedu-api-services/college-registration-api-service.js'

// 註冊所有 Vee-Validate 內建規則
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// 定義語系包
const locales = {
  tw: zh_TW,
  en: en
};

// 初始語系配置
if (window.app && window.app.$i18n) {
  localize(window.app.$i18n.locale === 'tw' ? 'zh_TW' : 'en', locales[window.app.$i18n.locale] || zh_TW);
} else {
  localize('zh_TW', zh_TW);
}

Vue.use(CardPlugin)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Divider)
Vue.use(LayoutPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(ButtonPlugin)

Vue.use(ConstantApiService)
Vue.use(CollegeRegistrationApiService)

export default {
  name: 'college-registration-form',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    collegeId: {
      type: Number,
      required: true
    },
    departments: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      current_step: 1,
      submitted: false,
      loading: false,
      form: {
        college_id: this.collegeId,
        name: '',
        birth_date: '',
        gender: null,
        phone: '',
        mobile_phone: '',
        email: '',
        line_id: '',
        address: '',
        education: null,
        organization: null,
        primary_department_id: null,
        other_department_ids: [],
        buddhist_background: '',
        studied_sutras: '',
        favorite_sutras: '',
        expectations: ''
      },
      constant: null
    };
  },
  watch: {
    'form.primary_department_id'(new_val) {
      if (new_val) {
        // 當主修變更時，自動從選修陣列中移除該 ID
        this.form.other_department_ids = this.form.other_department_ids.filter(id => id !== new_val);
        
        // 如果選中的是專屬班別，則清空所有選修
        if (this.is_primary_exclusive) {
          this.form.other_department_ids = [];
        }
      }
    },
    '$i18n.locale': {
      handler(new_locale) {
        localize(new_locale === 'tw' ? 'zh_TW' : 'en', locales[new_locale] || zh_TW);
      },
      immediate: true
    }
  },
  computed: {
    is_primary_exclusive() {
      if (!this.form.primary_department_id) return false;
      const department = this.departments.find(department => department.id === this.form.primary_department_id);
      return department && department.is_exclusive === 'Y';
    },
    available_other_departments() {
      // 過濾掉主修 ID，且過濾掉所有標記為專屬 (is_exclusive === 'Y') 的班別
      return this.departments.filter(department => {
        return department.id !== this.form.primary_department_id && department.is_exclusive !== 'Y';
      });
    },
    is_limit_reached() {
      const primary_count = this.form.primary_department_id ? 1 : 0;
      const other_count = this.form.other_department_ids.length;
      return (primary_count + other_count) >= 3;
    }
  },
  methods: {
    async nextStep() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        if (this.current_step < 3) {
          this.current_step++;
          this.$nextTick(() => {
            this.$refs.observer.reset();
          });
          window.scrollTo(0, 0);
        }
      } else {
        this.$nextTick(() => {
          const firstError = document.querySelector('.is-invalid, .invalid-feedback');
          if (firstError) {
             firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    },
    prevStep() {
      if (this.current_step > 1) {
        this.current_step--;
        window.scrollTo(0, 0);
      }
    },
    async setConstant() {
      const item = await this.$constantApiService.getFromMemberSystem()
      this.constant = item.data
    },
    getDepartmentName(id) {
      const department = this.departments.find(department => department.id === id);
      return department ? department.name : id;
    },
    getSelectedDepartmentsNames() {
      return this.form.other_department_ids.map(id => this.getDepartmentName(id)).join('、');
    },
    async onActualSubmit() {
      if (this.loading) return;
      this.loading = true;
      try {
        const result = await this.$collegeRegistrationApiService.create(this.form);
        if (result) {
          this.submitted = true;
          this.$emit('success', result);
        } else {
          alert('報名提交失敗，請稍後再試。');
        }
      } catch (error) {
        console.error(error);
        alert('報名提交時發生錯誤。');
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    await this.setConstant()
  }
};
</script>

<style scoped>
  /* 調整步驟容器背景顏色 */
  .van-steps {
    background-color: transparent;
  }

  /* 調整步驟標題文字大小 */
  ::v-deep .van-step__title {
    font-size: 1.15rem !important;
    font-weight: bold;
  }
  /* 調整未完成步驟的圓點大小 */
  ::v-deep .van-step__circle {
    width: 1.2em !important;
    height: 1.2em !important;
  }
  /* 調整選中/完成步驟的圖示大小 */
  ::v-deep .van-step__icon {
    font-size: 1.2rem !important;
  }
  
  /* 針對手機版 (螢幕寬度小於 768px) 的調整 */
  @media (max-width: 767px) {
    ::v-deep .van-step__title {
      font-size: 0.85rem !important;
      line-height: 1.2;
      /* 限制寬度並使用省略號防止擠壓 */
      max-width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
    ::v-deep .van-step--horizontal .van-step__circle-container {
      background-color: transparent !important;
    }
    
    ::v-deep .van-steps--horizontal {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  /* 增加容器高度以容納間距 */
  ::v-deep .van-steps--horizontal {
    padding-bottom: 25px;
  }
  /* 調整步驟標題文字間距 */
  ::v-deep .van-step--horizontal .van-step__title {
    margin-top: 10px;
    margin-bottom: 12px;
  }
  /* 調整步驟圓點容器間距 */
  ::v-deep .van-step--horizontal .van-step__circle-container {
    top: auto;
  }
  /* 調整步驟條容器間距 */
  ::v-deep .van-step--horizontal .van-step__line {
    top: auto;
  }
</style>
